module.exports = __webpack_public_path__ + "img/clever-hero.38dd57dd.png";